const has = require('lodash/fp/has');
const map = require('lodash/fp/map');
const merge = require('lodash/fp/merge');
const defaultParsePosition = require('./parse-position');
const defaultParseNewAssetPosition = require('./parse-position-newasset');
const defaultParseTransaction = require('./parse-transaction');
const defaultParseValueMovement = require('./parse-value-movement');
const memoizerPos = require('../request-handler/utils/memoizerPos');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const orderBy = require('lodash/orderBy');
/**
 * Assets Service Factory
 * @param {Object} config - config
 * @param {Function} config.api - API as provided by './api-factory'
 * @param {Object} config.commonQS - An object of query parameters added to every request
 * @param {Function} [config.parsePosition] - Fn to parse the API’s position response object
 * @param {Function} [config.parseTransaction] - Fn to parse the API’s transaction object
 * @param {Function} [config.parseValueMovement] - Fn to parse the API’s valueMovement object
 * @returns {Object} - The service { getPositions, getValueMovement, getTransactions }
 */

function addDataIndex(data){

  for (var i = 0; i < data.length; i++) {
    data[i].index = i;
  }

  return data;
}

function serviceFactory({
  api,
  parsePosition = defaultParsePosition,
  parseNewAssetPosition = defaultParseNewAssetPosition,
  parseTransaction = defaultParseTransaction,
  parseValueMovement = defaultParseValueMovement,
}) {
  const getPositionsLength = memoizerPos()((portfolioId, metaData) =>
    api.getPositions(portfolioId, metaData)
      .then(positions => positions.length));

  const getPositions = memoizerPos()((portfolioId, metaData, posId) =>
    api.getPositions(portfolioId, metaData, posId)
      .then(map(parseNewAssetPosition))
      .then(data => 
      {
        const parsedMetaData = parseRequestMetaData(metaData);
        let isAscending=parsedMetaData.assetSortAscending
        let assetSortKey=parsedMetaData.assetSortKey; 
        if(isAscending===null){
            return data;
        }
        else{
          let orderKey= isAscending? 'asc' : 'desc'
          let nulls = data.filter(x => x[assetSortKey] === null);     //WMCE-24126 for handling null values in sorting by seperating null values from dataset
          let nonNulls = data.filter(x => x[assetSortKey] !== null);
          let sortData = orderBy(nonNulls,[assetSortKey,'secID'],[orderKey,'asc']);    //WMCE-21564 for sorting records greater then mentioned assetPageSize in assets--WMCE 24933 -applying secondary sorting condition on position id in  ascending order
          let sortedData = [...sortData, ...nulls];                 //WMCE-24126 for handling null values in sorting by appending the null values 
          return sortedData;
        }
      })
      .then(addDataIndex)
    );

  const getValueMovement = memoizerPos()((portfolioId, positionIndex, metaData) =>
    getPositions(portfolioId, metaData)
      .then(positions => {
        if (!has([positionIndex], positions)) return [];
        return api.getValueMovement(
          {
            psSecNmb: positions[positionIndex].number,
            psActNmb: positions[positionIndex].number,
            psCcy: positions[positionIndex].currency,
            psRicCode: positions[positionIndex].ricCode,
            numberOfRows: 5,
          },
          metaData
        );
      })
      .then(map(parseValueMovement)));

  const getTransactions = memoizerPos()((portfolioId, positionIndex, metaData) =>
    getPositions(portfolioId, metaData)
      .then(positions => {
        if (!has([positionIndex], positions)) return [];
        return api.getTransactions(
          {
            posId: positions[positionIndex].secID,
          },
          metaData
        ).then(map(parseTransaction));
      }));

  return { getPositionsLength, getPositions, getValueMovement, getTransactions };
}

module.exports = serviceFactory;
